import { render, staticRenderFns } from "./InstitutionHistoryContent.vue?vue&type=template&id=bf37d5c0&scoped=true"
import script from "./InstitutionHistoryContent.vue?vue&type=script&lang=js"
export * from "./InstitutionHistoryContent.vue?vue&type=script&lang=js"
import style0 from "./InstitutionHistoryContent.vue?vue&type=style&index=0&id=bf37d5c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf37d5c0",
  null
  
)

export default component.exports